import { DestroyableObstacle } from "../destroyableObstacle";
import { ParticleType } from "../particleType";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";

export class DeskWithMachine extends DestroyableObstacle {
	static key = "DeskWithMachine";
	constructor(xy: XY) {
		super(xy);
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.METAL_DEBRIS;
	}

	static deserialize(data: any): DeskWithMachine {
		const d = new DeskWithMachine(deserializeXY(data.xy));
		d.restoreBaseFields(data);
		return d;
	}
}
